import gql from "graphql-tag";
import getUndef from "./get-undef";

const GET_BALANCE = gql`
  query getBalance($phone: String!) {
    customerBalance(phone: $phone)
  }
`;

export default async function getBalance(client, phone) {
  if (!phone) {
    return;
  }

  async function get() {
    try {
      const { data } = await client.query({
        query: GET_BALANCE,
        variables: {
          phone,
        },
      });
      return getUndef(() => data.customerBalance);
    } catch (error) {
      return;
    }
  }

  return await get();
}
